import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

import { useGetCommunitiesQuery, useCreateCommunityMutation } from '../../redux/communitiesService/communitiesApiSlice'

import GlobalStorage from '../../GlobalStore'

const Communities = () => {
	const navigate = useNavigate()
	const [createCommuinty] = useCreateCommunityMutation()
	const { data: community = [], error, isLoading } = useGetCommunitiesQuery()

	useEffect(() => {
		if (community?.length > 0 && !isLoading && !error) {
			goToCommunity(community?.[0])
		} else if (community?.length < 1 && !isLoading && !error) {
			createNewCommunity()
		}
	}, [community])

	const goToCommunity = (community) => {
		GlobalStorage.setItem('communityUid', community?.uid)
		GlobalStorage.setItem('communityName', community?.name)
		navigate('/tournaments')
	}

	const createNewCommunity = async () => {
		let language = navigator.language || navigator.userLanguage

		if (language?.length > 2) {
			language = language?.split('-')[0]
		}

		const body = {
			name: language !== 'ru' ? 'Community' : 'Сообщество',
			// country_code: language === 'ru' ? 'ru' : 'uk',
		}

		try {
			const response = await createCommuinty(body).unwrap()

			if (response?.error) {
				navigate('/login')
				return
			}
		} catch (e) {
			console.log('Community creation catched error', e)
		}
	}

	if (error) { console.log(error) }
	if (isLoading) { return <h1>Loading</h1> }

	return (
		<>
		</>
	)
}

export default Communities
